// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@fortawesome/fontawesome-svg-core/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Montserrat, sans-serif;
  font-size: 16px;
}

body {
  margin-top: 40px;
  padding: 16px;
  max-width: 100%;
}

h1 {
  font-size: 24px;
  font-weight: 700;
  color: #0f0d14;
}

p,
label {
  font-weight: 400;
  color: #6f6f6f;
}

button {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  background-color: #6BC0A9;
  color: white;
  margin-top: 40px;
}

input {
  height: 30px;
  border: 1px solid #e1d9fb;
  border-radius: 8px;
  padding: 4px 0px 4px 8px;
  margin-top: 8px;
}

input::placeholder {
  font-size: 16px;
  color: #9792a9;
}

.warning{
  padding: 30px 20px 30px 20px;
  background-color: #faece3;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
.warning img{
  margin-right: 10px;
}

.input-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  margin-bottom: 24px;
}

.input-container input {
  padding-right: 30px;
}

.input-container .toggle-password {
  position: absolute;
  top: 70%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #9792a9;
}

form {
  margin-top: 40px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.column {
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.gap-8 {
  gap: 8px;
}

.text-center {
  text-align: center;
}

.btn-disabled {
  background-color: #d7d7d7;
}

.text-bold {
  font-weight: 700;
  color: #6BC0A9;
}

.error {
  color: rgb(222, 0, 0);
}
.goApp {
  margin-top: 40px;
  display: block;
  text-align: center;
  background-color: #6cc0a9;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap');\n@import '@fortawesome/fontawesome-svg-core/styles.css';\n\n* {\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n}\n\nbody {\n  margin-top: 40px;\n  padding: 16px;\n  max-width: 100%;\n}\n\nh1 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f0d14;\n}\n\np,\nlabel {\n  font-weight: 400;\n  color: #6f6f6f;\n}\n\nbutton {\n  padding: 12px 24px;\n  border-radius: 8px;\n  border: none;\n  background-color: #6BC0A9;\n  color: white;\n  margin-top: 40px;\n}\n\ninput {\n  height: 30px;\n  border: 1px solid #e1d9fb;\n  border-radius: 8px;\n  padding: 4px 0px 4px 8px;\n  margin-top: 8px;\n}\n\ninput::placeholder {\n  font-size: 16px;\n  color: #9792a9;\n}\n\n.warning{\n  padding: 30px 20px 30px 20px;\n  background-color: #faece3;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n}\n.warning img{\n  margin-right: 10px;\n}\n\n.input-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.input-container input {\n  padding-right: 30px;\n}\n\n.input-container .toggle-password {\n  position: absolute;\n  top: 70%;\n  right: 10px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #9792a9;\n}\n\nform {\n  margin-top: 40px;\n}\n\n.flex-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.column {\n  flex-direction: column;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.gap-8 {\n  gap: 8px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.btn-disabled {\n  background-color: #d7d7d7;\n}\n\n.text-bold {\n  font-weight: 700;\n  color: #6BC0A9;\n}\n\n.error {\n  color: rgb(222, 0, 0);\n}\n.goApp {\n  margin-top: 40px;\n  display: block;\n  text-align: center;\n  background-color: #6cc0a9;\n  color: white;\n  text-decoration: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
